import { render, staticRenderFns } from "./bjnr.vue?vue&type=template&id=5c4376c6&scoped=true&"
import script from "./bjnr.vue?vue&type=script&lang=js&"
export * from "./bjnr.vue?vue&type=script&lang=js&"
import style0 from "./bjnr.vue?vue&type=style&index=0&id=5c4376c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4376c6",
  null
  
)

export default component.exports